import { HERO_STATS } from "../../utils/constants";
import { scrollToSection } from "../Navbar/Navbar";
import HeroTemplate from "./HeroTemplate";
import { NAV_LINKS } from "../../utils/constants";

export default function Hero() {
  return (
    <HeroTemplate
      stats={HERO_STATS}
      onPrimaryClick={() => scrollToSection(NAV_LINKS[3].id)}
      onSecondaryClick={() => scrollToSection(NAV_LINKS[0].id)}
    />
  );
}
